import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import usePDPFabricFilters from 'data-hooks/usePDPFabricFilters';
import usePDPFullScreenClickEvent from 'data-hooks/useEvents/usePDPFullScreenClickEvent';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useUpholsteryFilteredEvent from 'data-hooks/useEvents/useUpholsteryFilteredEvent';
import usePDPPrice from 'data-hooks/usePDPPrice';
import useFabricFavs from 'data-hooks/useFabricFavs';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPSelectUpholsteryUI from './PDPSelectUpholsteryUI';
import usePDPOptions from '../state/context/usePDPOptions';
import PDPSelectUpholsteryPlaceholder from './PDPSelectUpholsteryPlaceholder';
const PDPSelectUpholsteryInner = t0 => {
  const $ = _c(50);
  const {
    isEditOrder: t1,
    mode: t2,
    onMoreMaterialsClick,
    optionsLoading,
    productId: t3,
    slug,
    setMarxentSelectedFabric
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const mode = t2 === undefined ? "pdp" : t2;
  const productId = t3 === undefined ? null : t3;
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const {
    data: priceData
  } = usePDPPrice(productId, slug);
  const {
    loading,
    error,
    data: optionData,
    actions: t4
  } = usePDPOptions();
  const {
    onOptionValueHover,
    onOptionValueSelection
  } = t4;
  const {
    data: t5,
    actions: t6
  } = usePDPFabricFilters(slug, isEditOrder);
  const {
    activeColorFilters,
    activeNamedFilters,
    allMaterials,
    allMaterialsLength,
    disabledMaterialIds,
    favMaterials,
    filterCounts,
    filteredMaterials,
    flashSaleOptionIds,
    isClearanceFabricAvailable,
    isSelectedOptionsQuickship,
    optionName,
    selectedMaterial,
    selectedOptionsStockQty,
    upholsteryOptionId
  } = t5;
  const {
    clearAllFilters,
    toggleNamedFilter,
    toggleColorFilter
  } = t6;
  let t7;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      loadMaterialDetails: true
    };
    $[0] = t7;
  } else {
    t7 = $[0];
  }
  const {
    actions: t8
  } = useFabricFavs(t7);
  let t9;
  if ($[1] !== t8) {
    t9 = t8 === undefined ? {} : t8;
    $[1] = t8;
    $[2] = t9;
  } else {
    t9 = $[2];
  }
  const {
    setOptionAsFav,
    removeOptionAsFav
  } = t9;
  let t10;
  if ($[3] !== selectedMaterial || $[4] !== setMarxentSelectedFabric) {
    t10 = () => {
      if (selectedMaterial?.sku) {
        setMarxentSelectedFabric?.(selectedMaterial.sku.replace("-", ""));
      }
    };
    $[3] = selectedMaterial;
    $[4] = setMarxentSelectedFabric;
    $[5] = t10;
  } else {
    t10 = $[5];
  }
  const t11 = selectedMaterial?.sku;
  let t12;
  if ($[6] !== setMarxentSelectedFabric || $[7] !== t11) {
    t12 = [t11, setMarxentSelectedFabric];
    $[6] = setMarxentSelectedFabric;
    $[7] = t11;
    $[8] = t12;
  } else {
    t12 = $[8];
  }
  useEffect(t10, t12);
  const {
    fullScreenClickEvent
  } = usePDPFullScreenClickEvent(basicDetails, optionData, priceData);
  const {
    upholsteryFilteredEvent
  } = useUpholsteryFilteredEvent(basicDetails, optionData, priceData, "PDP");
  basicDetails?.id;
  basicDetails?.name;
  basicDetails?.type.name;
  let t13;
  if ($[9] !== removeOptionAsFav || $[10] !== setOptionAsFav) {
    t13 = {
      setOptionAsFav,
      removeOptionAsFav
    };
    $[9] = removeOptionAsFav;
    $[10] = setOptionAsFav;
    $[11] = t13;
  } else {
    t13 = $[11];
  }
  const t14 = basicDetails?.name;
  const t15 = basicDetails?.id;
  const t16 = basicDetails?.type.name;
  let t17;
  if ($[12] !== t14 || $[13] !== t15 || $[14] !== t16) {
    t17 = {
      name: t14,
      productId: t15,
      category: t16
    };
    $[12] = t14;
    $[13] = t15;
    $[14] = t16;
    $[15] = t17;
  } else {
    t17 = $[15];
  }
  const t18 = allMaterials?.[0];
  let t19;
  if ($[16] !== favMaterials || $[17] !== t17 || $[18] !== t18) {
    t19 = {
      favMaterials,
      favProductData: t17,
      defaultToMaterial: t18
    };
    $[16] = favMaterials;
    $[17] = t17;
    $[18] = t18;
    $[19] = t19;
  } else {
    t19 = $[19];
  }
  let t20;
  if ($[20] !== t13 || $[21] !== t19) {
    t20 = {
      actions: t13,
      data: t19
    };
    $[20] = t13;
    $[21] = t19;
    $[22] = t20;
  } else {
    t20 = $[22];
  }
  const fabricFavProps = t20;
  if (error) {
    return null;
  }
  const t21 = loading || optionsLoading;
  let t22;
  if ($[23] !== activeColorFilters || $[24] !== activeNamedFilters || $[25] !== allMaterialsLength || $[26] !== clearAllFilters || $[27] !== disabledMaterialIds || $[28] !== fabricFavProps || $[29] !== filterCounts || $[30] !== filteredMaterials || $[31] !== flashSaleOptionIds || $[32] !== fullScreenClickEvent || $[33] !== isClearanceFabricAvailable || $[34] !== isEditOrder || $[35] !== isSelectedOptionsQuickship || $[36] !== mode || $[37] !== onMoreMaterialsClick || $[38] !== onOptionValueHover || $[39] !== onOptionValueSelection || $[40] !== optionName || $[41] !== selectedMaterial || $[42] !== selectedOptionsStockQty || $[43] !== slug || $[44] !== t21 || $[45] !== toggleColorFilter || $[46] !== toggleNamedFilter || $[47] !== upholsteryFilteredEvent || $[48] !== upholsteryOptionId) {
    t22 = <PDPSelectUpholsteryUI activeColorFilters={activeColorFilters} activeNamedFilters={activeNamedFilters} allMaterialsLength={allMaterialsLength} clearAllFilters={clearAllFilters} disabledMaterialIds={disabledMaterialIds} fabricFavProps={fabricFavProps} filterCounts={filterCounts} flashSaleOptionIds={flashSaleOptionIds} fullScreenClickEvent={fullScreenClickEvent} isClearanceFabricAvailable={isClearanceFabricAvailable} isEditOrder={isEditOrder} isSelectedOptionsQuickship={isSelectedOptionsQuickship} loading={t21} materials={filteredMaterials} mode={mode} onMoreMaterialsClick={onMoreMaterialsClick} onOptionValueHover={onOptionValueHover} onOptionValueSelection={onOptionValueSelection} selectedMaterial={selectedMaterial} selectedOptionsStockQty={selectedOptionsStockQty} slug={slug} toggleColorFilter={toggleColorFilter} toggleNamedFilter={toggleNamedFilter} upholsteryFilteredEvent={upholsteryFilteredEvent} upholsteryOptionId={upholsteryOptionId} upholsteryOptionName={optionName} />;
    $[23] = activeColorFilters;
    $[24] = activeNamedFilters;
    $[25] = allMaterialsLength;
    $[26] = clearAllFilters;
    $[27] = disabledMaterialIds;
    $[28] = fabricFavProps;
    $[29] = filterCounts;
    $[30] = filteredMaterials;
    $[31] = flashSaleOptionIds;
    $[32] = fullScreenClickEvent;
    $[33] = isClearanceFabricAvailable;
    $[34] = isEditOrder;
    $[35] = isSelectedOptionsQuickship;
    $[36] = mode;
    $[37] = onMoreMaterialsClick;
    $[38] = onOptionValueHover;
    $[39] = onOptionValueSelection;
    $[40] = optionName;
    $[41] = selectedMaterial;
    $[42] = selectedOptionsStockQty;
    $[43] = slug;
    $[44] = t21;
    $[45] = toggleColorFilter;
    $[46] = toggleNamedFilter;
    $[47] = upholsteryFilteredEvent;
    $[48] = upholsteryOptionId;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  return t22;
};
PDPSelectUpholsteryInner.propTypes = {
  isEditOrder: PropTypes.bool,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  onMoreMaterialsClick: PropTypes.func,
  optionsLoading: PropTypes.bool,
  productId: PropTypes.number,
  setMarxentSelectedFabric: PropTypes.func,
  slug: PropTypes.string
};
const PDPSelectUpholstery = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PDPSelectUpholsteryPlaceholder />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPSelectUpholsteryInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPSelectUpholstery;